import { render } from "./CreateRequest4.vue?vue&type=template&id=b794279e"
import script from "./CreateRequest4.vue?vue&type=script&lang=js"
export * from "./CreateRequest4.vue?vue&type=script&lang=js"

import "./CreateRequest4.vue?vue&type=style&index=0&id=b794279e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__